import Link from "next/link";
import { useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import styles from "./style.module.scss";
import { parseHtml, toWebp } from "../../../utils/common";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const Explore = ({ data }) => {
  const [technologyArray, setTechnologyArray] = useState([]);

  const renderTooltip = (props, title) => (
    <Tooltip className={styles["case-tool-tip"]} id="button-tooltip" {...props}>
      <span>{title}</span>
    </Tooltip>
  );

  useEffect(() => {
    const createArrayChunks = () => {
      let techArray = [...data?.images?.[0]?.technologies];
      if (techArray) {
        setTechnologyArray([
          techArray.splice(0, 3),
          techArray.splice(0, 4),
          techArray.splice(0, 3),
        ]);
      }
    };

    createArrayChunks();
  }, [data?.images]);

  return (
    <section className={`${styles["explore-section"]}  bg-one home-padding-new`}>
      <Container className={styles["container"]}>
        <Row className="align-items-center explore-row-space">
          <Col lg={6} md={6}>
            <Row className="align-items-center explore-inline-space">
              {technologyArray?.map((arrayChunk, i) => (
                <Col key={i} lg={4} md={4} xs={4}>
                  <Row>
                    {arrayChunk?.map((image, index) => (
                      <Col lg={12} key={index}>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 500 }}
                          overlay={(props) =>
                            renderTooltip(props, image?.title)
                          }
                        >
                          <div className={`${styles["explore-logo"]} border-2 border-color bg-white`}>
                            <Image
                              src={toWebp(
                                `${baseUrl}${image?.image?.data?.attributes?.url}`
                              )}
                              alt={image?.image?.data?.attributes?.name}
                            />
                          </div>
                        </OverlayTrigger>
                      </Col>
                    ))}
                  </Row>
                </Col>
              ))}
            </Row>
          </Col>
          <Col lg={6} md={6}>
            <div className={styles["explore-project-content"]}>
              <h2 className="text-black">{data?.title}</h2>
              <ul className={styles["next-project-list"]}>
                {data?.points?.map((point) => (
                  <li key={point.id} className="text-black text-normal font-regular">
                    <Image
                      src="/images/home/explore-pattern-icon.svg"
                      alt="project-img"
                    />
                    {point.title}
                    {parseHtml(point?.text)}
                  </li>
                ))}
              </ul>
              {data?.cta && (
                <Link href={data.cta.href} className="btn btn-primary">
                  {data.cta.label}
                </Link>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Explore;
